(function Module() {
	'use strict';
//import {log,_,moment,mySynchEnumeration} from '../globals';
	const {log,_,moment,mySynchEnumeration} = require('../globals');

	module.exports = window.mySynch = angular.module('mySynch', [
		'ng',
		'ui.router',
		'ui.router.upgrade',
		'dx',
		'AdalAngular',
		'ngCookies',
		'ngAnimate',
		'ui.bootstrap',
		'ng.deviceDetector',
		'ngclipboard',
		'angularjs-dropdown-multiselect'
	]);
	

	// Configure routes
	angular.module('mySynch').config([
		'$urlServiceProvider',
		'$stateProvider',
		'$urlRouterProvider',
		'$httpProvider',
		'adalAuthenticationServiceProvider',
		function mySynchConfig($urlServiceProvider,$stateProvider, $urlRouterProvider, $httpProvider, adalAuthenticationServiceProvider,$templateCache) {
			$urlServiceProvider.deferIntercept()
			$stateProvider
			.state('Help',			        {url: '/Help',			            external: false,												component: "help"})
			.state('Alerts',				{url: '/Alerts',				    external: false,												templateUrl: 		 'partials/alerts/alerts.list.view.html'})
			.state('BenchmarkingInsights',	{url: '/BenchmarkingInsights',	    external: false,												templateUrl: 		 'partials/insights/benchmarking.details.view.html'})
			.state('Definitions',			{url: '/Definitions',			    external: false,												templateProvider:  [ '$templateCache',function($templateCache){ return $templateCache.get('partials/resources/definitions.view.jade');}]})
			.state('Error',					{url: '/Error',					    external: false,												templateProvider:  [ '$templateCache',function($templateCache){ return $templateCache.get('partials/error/error.view.jade');}]})
			.state('FertilityCodes',		{url: '/FertilityCodes',		    external: false,												templateProvider:  [ '$templateCache',function($templateCache){ return $templateCache.get('partials/breeding/codes.programs.view.jade');}],			params: {program: null}})
			.state('FertilityDashboard',	{url: '/FertilityDashboard',	    external: false,												templateProvider:  [ '$templateCache',function($templateCache){ return $templateCache.get('partials/dashboards/fertility.dashboard.view.jade');}]})

			.state('Journal',		        {url: '/Journal',				     external: false,							                    component: "journal"})
			.state('NewJournal',			{url: '/JournalMaint/:cameFrom',     external: false,												component: "journalMaint", params: {cameFrom: null}})
			.state('JournalEdit',			{url: '/JournalMaint/:id/:cameFrom', external: false,												component: "journalMaint", params: {id: null, cameFrom: null}})

			.state('CohortDetail',			{url: '/CohortDetail',				 external: false,												templateProvider:  [ '$templateCache',function($templateCache){ return $templateCache.get('partials/dashboards/cohort.detail.view.jade');}],		params: {cohort: null, rha: null}})
			.state('FertilityAnalysis',		{url: '/FertilityAnalysis',			 external: false,												templateProvider:  [ '$templateCache',function($templateCache){ return $templateCache.get('partials/dashboards/fertilityanalysis.view.jade');}]})
			.state('KpiDashboard',			{url: '/KpiDashboard',				 external: false,												component: "kpiDashboard"})
			.state('Login',					{url: '/Login',						 external: false,												component: "login"})
			.state('ForgotPassword',		{url: '/ForgotPassword',			 external: false,												component: "forgotPassword",		params: {expired: false}})
			.state('PasswordReset',			{url: '/password-reset',			 external: false,												component: "passwordReset"})
			
			.state('FarmAdmin',				{url: '/FarmAdmin',					 external: false,												component: "farmDemographics"})
			//.state('BreedingCodes',			{url: '/FarmAdmin/breedingcodes',	 external: false,												templateProvider:  [ '$templateCache', function($templateCache){ return $templateCache.get('partials/farms/farm.breeding-codes.view.jade');}]})
			.state('HerdData',			    {url: '/FarmAdmin/herdData',	     external: false,												component: "herdData"})
			.state('UserManagement',	    {url: '/FarmAdmin/userManagement',	 external: false,												component: "userManagement"})
			
			
			.state('Education',		        {url: '/Education',	                 external: false})
			.state('User',					{url: '/User',						 external: false,																component: "userProfile"})
			.state('WelcomeToFarm',			{url: '/Welcome/:personKey/:farmId', external: false,																component: "newUser"})
			.state('Welcome',				{url: '/Welcome/:personKey',		 external: false,																component: "newUser"})
			.state('Technicians',			{url: '/Technicians', redirectState: 'ConceptionDashboard',	external: false,										templateProvider: [ '$templateCache', function($templateCache){ return $templateCache.get('partials/dashboards/techicians.dashboard.view.jade');}]})
			.state('Sires',					{url: '/Sires',       redirectState: 'ConceptionDashboard',	external: false,										templateProvider: [ '$templateCache', function($templateCache){ return $templateCache.get('partials/dashboards/sires.dashboard.view.jade');}]})
			
			.state('Benchmarking',			{url: '/Benchmarking',				 external: false,													templateProvider: [ '$templateCache', function($templateCache){ return $templateCache.get('partials/dashboards/benchmarking.view.jade');}]})
			.state('BenchmarkingApp',		{url: '/BenchmarkingApp',			 external: false,													component: "benchmarking"})
			.state('SpecialReports',		{url: '/SpecialReports',			 external: false,												    component: "specialReports"})
			.state('Fertility360report',	{url: '/f360',						 external: false,													templateProvider: [ '$templateCache',function($templateCache){ return $templateCache.get('partials/fertility360report/fertility360report.view.jade');}]})
			.state('PublishedReport',		{url: '/f360/:id',					 external: false,											    	templateProvider: [ '$templateCache',function($templateCache){ return $templateCache.get('partials/fertility360report/published-report.view.jade');}]})
			.state('EvaluationOverview',	{url: '/f360/:id/evaluation-overview',                                      		external: false,	templateProvider: [ '$templateCache','AuditService','$q',function($templateCache, auditService,$q){
																																																			     var promise = $q.defer();
																																																		      	 auditService.getActiveOrCurrentAuditVersion(null).then(function(auditVersion){
																																																				    promise.resolve($templateCache.get(`partials/fertility360report/${auditVersion}/evaluation-overview.view.jade`));
																																																		  	     });													
																																																			     return promise.promise;
																																																         }]})
			.state('ResultWriteReport',	    {url: '/f360/:id/evaluation-overview/result-write-report',                          external: false,	templateProvider: [ '$templateCache','AuditService','$q',function($templateCache, auditService,$q){
																																																                 var promise = $q.defer();
																																															          	         auditService.getActiveOrCurrentAuditVersion(null).then(function(auditVersion){
																																															  		                promise.resolve($templateCache.get(`partials/fertility360report/${auditVersion}/result-write-report.view.jade`));
																																															                 	 });													
																																																                 return promise.promise;
																																														                 }]})
			.state('ReviewDraftReport',	    {url: '/f360/:id/evaluation-overview/result-write-report/review-draft-report',      external: false,	templateProvider: [ '$templateCache','AuditService','$q',function($templateCache, auditService,$q){
																																																				var promise = $q.defer();
																																																				auditService.getActiveOrCurrentAuditVersion(null).then(function(auditVersion){
																																																					promise.resolve($templateCache.get(`partials/fertility360report/${auditVersion}/review-draft-report.view.jade`));
																																																				});													
																																																				return promise.promise;
																																													          	         }]})
			.state('SectionPage',			{url: '/f360/:id/evaluation-overview/:section', 	                                external: false,	templateProvider: [ '$templateCache','AuditService','$q',function($templateCache, auditService,$q){
																																																			    var promise = $q.defer();																																															
																																																			    auditService.getActiveOrCurrentAuditVersion(null).then(function(auditVersion){
																																																				    //var auditApiVersion = _.get($stateParams,'apiVersion');
																																												                                    promise.resolve( $templateCache.get(`partials/fertility360report/${auditVersion}/section-page.view.jade`));
																																																		     	});													
																																																			    return promise.promise;
																																																         }]})
			.state('LamenessScoring',	    {url: '/f360/:id/evaluation-overview/:subHeading/:typeName/lameness-scoring',	    external: false,	templateProvider: [ '$templateCache','AuditService','$q',function($templateCache, auditService,$q){ 
																																																      	        var promise = $q.defer();
																																																	            auditService.getActiveOrCurrentAuditVersion(null).then(function(auditVersion){

																																																		            promise.resolve( $templateCache.get(`partials/fertility360report/${auditVersion}/lameness-scoring.view.jade`));
																																																	            });													
																																																	            return promise.promise;
																																																
																																																          }]})
			.state('BodyConditionScoring',	{url: '/f360/:id/evaluation-overview/:subHeading/:typeName/body-condition-scoring', external: false,	templateProvider: [ '$templateCache','AuditService','$q',function($templateCache, auditService,$q){ 
																																																                var promise = $q.defer();
																																																                auditService.getActiveOrCurrentAuditVersion(null).then(function(auditVersion){
																																																                 	promise.resolve( $templateCache.get(`partials/fertility360report/${auditVersion}/body-scoring.view.jade`));
																																																                });													
																																															   	                return promise.promise;
																																															              }]})
			// Admin Screens
			.state('AdminUserManagement',		{url: '/admin/AdminUserManagement',						external: false,							component: "adminUserManagement"})
			.state('AdminUserManagementMaint',	{url: '/admin/AdminUserManagementMaint/:personId',	 	external: false,  params:{personId: null},	component: "adminUserManagementMaint"})
		
			.state('FarmManagement',	    	{url: '/admin/FarmManagement',							external: false,							component: "adminFarmManagement"})
			.state('FarmManagementMaint',   	{url: '/admin/FarmManagementMaint/:farmId', 			external: false,  params:{farmId: null,tmDashSelectedTabName: null},    component: "adminFarmManagementMaint"})

			.state('TerritoryDashboard',		{url: '/admin/TerritoryDashboard/:selectedTabName',		external: false,  params:{selectedTabName: null},   component: "tmDashboard"})
			.state('NewFarm',					{url: '/admin/Farm/new',								external: false,							templateProvider: [ '$templateCache', function($templateCache){ return $templateCache.get('partials/admin/farm.new.view.jade');}]})
			
			.state('TrendsAndTargets',			{url: '/TrendsAndTargets',								external: false,							component: "trendsAndTargets"})
			.state('SeasonalTrends',			{url: '/SeasonalTrends',								external: false,							templateProvider: [ '$templateCache', function($templateCache){ return $templateCache.get('partials/pythoncharts/seasonal.trends.view.jade');}]})
			
			.state('EmmRetrieveShotList',		{url: '/eMM/EmmRetrieveShotList',						external: false,							templateProvider: [ '$templateCache', function($templateCache){ return $templateCache.get('partials/eMM/emm.retrieve.shotlist.view.jade');}]})
			.state('EmmFieldReports',		    {url: '/eMM/EmmFieldReports',						    external: false,							templateProvider: [ '$templateCache', function($templateCache){ return $templateCache.get('partials/eMM/emm.field.reports.view.jade');}]})

			.state('FarmGoalManagement',		{url: '/FarmGoalManagement',     						external: false,							templateProvider:  [ '$templateCache',function($templateCache){ return $templateCache.get('partials/farms/farm.goal.mgmt.view.jade');}]})
			.state('AdminItemDetails',			{url: '/AdminItem',     								external: false,							templateProvider:  [ '$templateCache',function($templateCache){ return $templateCache.get('partials/farms/farm.goal.mgmt.view.jade');}]})

			// Dashboards
			.state('MultiFarmDashboard',		{url: '/MyFarms',					                    external: false,							templateProvider: [ '$templateCache', function($templateCache){ return $templateCache.get('partials/dashboards/multi.farm.dashboard.view.jade');}]})
			.state('MyFarmRanks',		        {url: '/MyFarmRanks',					                external: false,							templateProvider: [ '$templateCache', function($templateCache){ return $templateCache.get('partials/farms/my.farm.ranks.view.jade');}]})
			.state('ConceptionDashboard',		{url: '/ConceptionDashboard',						    external: false,							component: "conceptionDashboard"})
			.state('FertilityCalendars',		{url: '/FertilityCalendars',						    external: false,							component: "fertilityCalendars"})
;
              

			$urlRouterProvider.otherwise(function otherwise($injector, $location) {
				log.debug('otherwise route handler: ' + _.get($location,'$location.$$absUrl'));
				
				// since we don't have a base root page for the site (ex: https://mysynch.parnell.com/ ) , another part of the app needs
				// too know if we loaded in fresh vs refreshing the browser while already on the site.
				// loadedFromSiteRoot will be set true irregardless of the user's logged in status. 

                var MSF = $injector.get('MySynchFactory');
				var viewAuth = $injector.get('ViewAuthorizationFactory');
				var mySynchEnumSvc = $injector.get('mySynchEnumerationService');
				var mysynchConstSvc = $injector.get('mySynchConstantService');
                
				
				if (viewAuth.checkUser()) {
					var optionalParams = {};
					var rolesByFarm = _.get(MSF.cookies.user,'rolesByFarm',[]);
					var isTM = _.any(rolesByFarm,function(role){
						return _.contains(_.keys(role),mySynchEnumSvc.getMySynchEnumerationName("Role","TERRITORY_MANAGER"));
					  });
					// if the user is a territory manager, we need to supply the default tab name of the territory dashboard
					if (isTM) {
						_.set(optionalParams,'selectedTabName',mysynchConstSvc.defaultTerritoryManagerDashboardTab);
					}
				 var homePageStateName =	MSF.getUserHomepageStateName(true);
				 MSF.loadPage(homePageStateName,optionalParams);
					
			    }else{
					MSF.loadPage('Login');
				}
			
				
			});

			adalAuthenticationServiceProvider.init({
				tenant: 'mysynchdevad.onmicrosoft.com',
				clientId: 'd1575a3d-21f8-4ea0-8956-f389d729decc'},
				$httpProvider
			);
		}
	]);

	angular.module('mySynch').run([
		'$rootScope',
		'$transitions',
		'$window',
		'ViewAuthorizationFactory',
		'MySynchFactory',
		'ApplicationInsightsFactory',
		'pageTrackerService',
		'mySynchDataStore',
		'broadCastService',
		'modalService',
		'modalDataService',
		'deviceDetector',
		'performanceMetricsService',
		function runWithDependencies($rootScope, $transitions,$window, viewAuth, MSF, aif, pageTracker,mySynchDataStore,broadCastService,modalService,modalDataService,deviceDetector,perfMetricSvc) {
			$rootScope._ = _;
			$rootScope.moment = moment;
			$rootScope.MSF = MSF;
			$window.MSF = MSF;
			$rootScope.isMobile = deviceDetector.isMobile();
			$rootScope.deviceDetector = deviceDetector;
			

			$transitions.onBefore({}, function(state) {	
				var next = state.to();
				var nextParams = state.params('to');
				var current = state.from();
				var currentParams = state.params('from');

				perfMetricSvc.logWatcherCount(`Watchers:${next.name}:BeforeTransitionStart`);
				perfMetricSvc.logMemoryUsage(`Memory:${next.name}:BeforeTransitionStart`);
			});
			
			$transitions.onStart({}, function(state) {
				var next = state.to();
				var nextParams = state.params('to');
				var current = state.from();
				var currentParams = state.params('from');
				
			    log.warn('changing state ' + (current.name ? 'from ' + current.name + ' ' : '') + 'to ' + next.name);

				var activeFarm = MSF.getActiveFarm();
				var activeHerd = _.get(activeFarm,'herds[0]');

				// if page goes to an extrnal page  
				if (next.external === true) {
					$window.open(next.targetUrl, next.target);
				}

				var redirectState = _.get(next,'redirectState');
				if(!_.isUndefined(redirectState)){
                    var activeFarm = MSF.getActiveFarm();
					var activeHerd = _.get(activeFarm,'herds[0]');

					MSF.loadPageForFarmId(redirectState,_.get(activeHerd,'herdId'),_.get(activeFarm,'farmId'),true,"user",false,true);
					return false;
				}

				var authorizedPage = viewAuth.getAuthorizedPage(next.name);
				
				if (next.name !== authorizedPage) {
					log.info('unauthorized. redirecting to login');
					MSF.loadPage(authorizedPage, nextParams);
					return false;
				}
                
                // initialize some mysynch datastore variables
                var currentPageType = mySynchDataStore.getCurrentPageType();
                if (_.isUndefined(currentPageType) || _.isEmpty(currentPageType)){
                                            
                    var pageType =  MSF.getPageTypeByState(next.name); 
                    mySynchDataStore.setCurrentPageType(pageType);   
                }

				//------------------------------------------------------------//
				// App level notification checks
			    //------------------------------------------------------------//
				
				// Out Of Date Data
				// ADDING TEMP COMMENT TO TEST ZIP DEPLOY
				if( (!_.isUndefined(activeHerd) && !_.isEmpty(activeHerd)) && (!_.isUndefined(_.get(MSF,'cookies.user')) && !_.isEmpty(_.get(MSF,'cookies.user'))))    
				{
					// currently we are only getting DC305 Events. So we only need to check for data currrncy if the herdMgmtSoftware is DC305
					if(_.isEqual(_.get(activeHerd,'herdMgmtSoftware'),'DC305')){
					  modalService.checkDataCurrency();
					}	
				}
									
				//------------------------------------------------------------//

				// broadcast the new State for Angular 14
				broadCastService.stateChangeMsg({state:{name:next.name,url:next.url,params:next.params}})
				
			});

			$transitions.onSuccess({}, (state) => {
				var next        = state.to();
				var nextParams  = state.params('to');
				var current     = state.from();
				var currentParams = state.params('from');

				var personKey	= (_.get(MSF, 'cookies.user.PersonKey'));
				var herdKey		= (_.get(MSF, 'activeHerd.herdKey'));

				if (!herdKey) {
					herdKey = (_.get(MSF, 'cookies.state.activeFarm.herds[0].herdKey'));
				}

				if (personKey) {	
					window.ga('set', 'userId',	personKey);
					window.ga('set', 'dimension1',	personKey);
				}

				if (herdKey) {
					window.ga('set', 'dimensionw2', herdKey);
				}

				// some states need to send their Url to GA instead of the state name
                var pageView = next.name;
				if(_.includes(MSF.urlGAStates,next.name)){
					pageView = MSF.getFullUrlWithParams(next.url,nextParams);
				}
				window.ga('send', 'pageview', pageView);

				aif.trackPageView(next.name);

				if (personKey && herdKey) {
					pageTracker.trackPageView(personKey, herdKey, next.name);	// no need to pass a callback because this is fire and forget
				}
				// record current watchers count after transition success
				perfMetricSvc.logWatcherCount(`Watchers:${next.name}:AfterTransitionSuccess`);
				// record the scope count after transition success
				perfMetricSvc.logScopeCount(`Scopes:${next.name}:AfterTransitionSuccess`);
				// record current memory usage after transition success
				perfMetricSvc.logMemoryUsage(`Memory:${next.name}:AfterTransitionSuccess`);
				// record the heap growth detected after the transition success
				perfMetricSvc.logHeapGrowthDelta(`Memory:${next.name}:AfterTransitionSuccess:HeapGrowthDelta`);

				$rootScope.MSF.previousState = current;
				$rootScope.$broadcast("state:changed", {from: current,to: next});
			});

			$rootScope.onLine = $window.navigator.onLine;
            $window.addEventListener("offline", function() {
                  $rootScope.onLine = false;
                  $rootScope.$broadcast('online:change',{value :  $rootScope.onLine});
            }, false);

            $window.addEventListener("online", function() {
               $rootScope.$apply(function() {
				  $rootScope.onLine = true;
				  $rootScope.$broadcast('online:change',{value :  $rootScope.onLine});
               });
            }, false);
		}
	]);

	var serviceBase = 'https://localhost:44300';
	angular.module('mySynch').constant('ngAuthSettings', {
		apiServiceBaseUri: serviceBase
	});
	//#region Ng directives
	/*  We extend Angular with custom data bindings written as Ng directives */
	angular.module('mySynch').directive('onFocus', function directiveOnFocus() {
		return {
			restrict: 'A',
			link: function onFocusLink(scope, elm, attrs) {
				elm.bind('focus', function bindFocus() {
					scope.$apply(attrs.onFocus);
				});
			}
		};
	}).directive('onBlur', function directiveOnBlur() {
		return {
			restrict: 'A',
			link: function onBlurLink(scope, elm, attrs) {
				elm.bind('blur', function bindBlur() {
					scope.$apply(attrs.onBlur);
				});
			}
		};
	}).directive('onEnter', function directiveOnEnter() {
		return function onEnterFn(scope, element, attrs) {
			element.bind('keydown keypress', function bindKeyEvents(event) {
				if (event.which === 13) {
					scope.$apply(function applyFn() {
						scope.$eval(attrs.onEnter);
					});

					event.preventDefault();
				}
			});
		};
	}).directive('selectedWhen', function directiveSelectedWhen() {
		return function selectedWhenFn(scope, elm, attrs) {
			scope.$watch(attrs.selectedWhen, function watchSelectedWhen(shouldBeSelected) {
				if (shouldBeSelected) {
					elm.select();
				}
			});
		};
	});

	var supportsPlaceholder= function(){
		var i = document.createElement('input');
		return 'placeholder' in i;
	};

	
	if (!supportsPlaceholder()) {
		// this browser does not support HTML5 placeholders
		// see http://stackoverflow.com/questions/14777841/angularjs-inputplaceholder-directive-breaking-with-ng-model
		angular.module('mySynch').directive('placeholder', function directivePlaceholder() {
			return {
				restrict: 'A',
				require: 'ngModel',
				link: function placeholderLink(scope, element, attr, ctrl) {
					var value;
					var modelWatchDeReg = undefined;

					var placeholder = function placeholderFn() {
						element.val(attr.placeholder);
					};
					var unplaceholder = function unplaceholderFn() {
						element.val('');
					};

					modelWatchDeReg = scope.$watch(attr.ngModel, function watchNgModel(val) {
										 value = val || '';
									  });

					element.bind('focus', function bindFocus() {
						if (value === '') {
							unplaceholder();
						}
					});

					element.bind('blur', function bindBlur() {
						if (element.val() === '') {
							placeholder();
						}
					});

					ctrl.$formatters.unshift(function unshiftFn(val) {
						if (!val) {
							placeholder();
							value = '';

							return attr.placeholder;
						}

						return val;
					});

					scope.$on('$destroy', function onDestroy() {
						if(modelWatchDeReg){
							console.log('!!!!!!!!!!!!!!unregistering model watch for placeholder directive !!!!!!!!!!!!!');
						   modelWatchDeReg();
						}
					});
				}
			};
		});
	}
	//#endregion
    

	

})();
